"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconConvenienceApiServiceImpl = void 0;
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var Cache_1 = require("../../decorators/Cache");
/**
 * Rest implementation of the example service
 */
var FalconConvenienceApiServiceImpl = exports.FalconConvenienceApiServiceImpl = /** @class */ (function (_super) {
    __extends(FalconConvenienceApiServiceImpl, _super);
    function FalconConvenienceApiServiceImpl(configuration, notificationService) {
        var _this = _super.call(this) || this;
        _this.configuration = configuration;
        _this.notificationService = notificationService;
        return _this;
    }
    FalconConvenienceApiServiceImpl.prototype.analyzeDriversLicenceFront = function (driversLicenceImage, quoteId) {
        var body = {
            image: driversLicenceImage
        };
        return this.doRequest("/driver-licence-front?quoteId=".concat(quoteId), "POST", body);
    };
    FalconConvenienceApiServiceImpl.prototype.analyzeDriversLicenceBack = function (driversLicenceImage, quoteId) {
        var body = {
            image: driversLicenceImage
        };
        return this.doRequest("/driver-licence-back?quoteId=".concat(quoteId), "POST", body);
    };
    FalconConvenienceApiServiceImpl.prototype.getRegistrationNumber = function (vehicleImage) {
        var body = {
            image: vehicleImage
        };
        return this.doRequest("/registration-number", "POST", body);
    };
    FalconConvenienceApiServiceImpl.prototype.getAddressDetailsByPostcodeAndBuilding = function (partialAddress, limit, offset) {
        return this.doRequest("/address-lookup-postcode-building?partialAddress=".concat(partialAddress, "&limit=").concat(limit, "&offset=").concat(offset));
    };
    FalconConvenienceApiServiceImpl.prototype.getEalsAddressDetailsByPostcodeAndBuilding = function (postcode, building) {
        return this.doRequest("/eals-address-list?postcode=".concat(postcode, "&building=").concat(building));
    };
    FalconConvenienceApiServiceImpl.prototype.getEalsAddressDetails = function (addressDetails) {
        return this.doRequest("/eals-address-details", "POST", addressDetails);
    };
    FalconConvenienceApiServiceImpl.prototype.getVehicleManufacturerDetails = function (partialVehicleManufacturer) {
        return this.doRequest("/vehicle-manufacturer-lookup?partialVehicleManufacturer=".concat(partialVehicleManufacturer));
    };
    FalconConvenienceApiServiceImpl.prototype.getVehicleModelYears = function (vehicleManufacturer, shortenedModel) {
        if (shortenedModel) {
            return this.doRequest("/vehicle-model-years-annual?vehicleManufacturer=".concat(vehicleManufacturer, "&vehicleShortenedModel=").concat(shortenedModel));
        }
        else {
            return this.doRequest("/vehicle-model-years-annual?vehicleManufacturer=".concat(vehicleManufacturer));
        }
    };
    FalconConvenienceApiServiceImpl.prototype.getVehicleTransmissions = function (vehicleManufacturer, manufactureYear, shortenedModel) {
        if (shortenedModel) {
            return this.doRequest("/vehicle-transmissions-annual?vehicleManufacturer=".concat(vehicleManufacturer, "&manufactureYear=").concat(manufactureYear, "&vehicleShortenedModel=").concat(shortenedModel));
        }
        else {
            return this.doRequest("/vehicle-transmissions?vehicleManufacturer=".concat(vehicleManufacturer, "&manufactureYear=").concat(manufactureYear));
        }
    };
    FalconConvenienceApiServiceImpl.prototype.getVehicleFuelTypes = function (vehicleManufacturer, manufactureYear, transmission, shortenedModel) {
        if (shortenedModel) {
            return this.doRequest("/vehicle-fuel-types-annual?vehicleManufacturer=".concat(vehicleManufacturer, "&vehicleShortenedModel=").concat(shortenedModel, "&manufactureYear=").concat(manufactureYear, "&transmission=").concat(transmission));
        }
        else {
            return this.doRequest("/vehicle-fuel-types?vehicleManufacturer=".concat(vehicleManufacturer, "&manufactureYear=").concat(manufactureYear, "&transmission=").concat(transmission));
        }
    };
    FalconConvenienceApiServiceImpl.prototype.getVehicleEngineSizes = function (manufacturer, manufactureYear, transmission, fuelType) {
        return this.doRequest("/vehicle-engine-sizes?vehicleManufacturer=".concat(manufacturer, "&manufactureYear=").concat(manufactureYear, "&transmission=").concat(transmission, "&fuelCode=").concat(fuelType));
    };
    FalconConvenienceApiServiceImpl.prototype.getVehicleDoors = function (manufacturer, manufactureYear, transmission, fuelType, engineSize, shortenedModel) {
        var queryParams = "vehicleManufacturer=".concat(manufacturer, "&manufactureYear=").concat(manufactureYear, "&transmission=").concat(transmission, "&fuelCode=").concat(fuelType);
        queryParams = this.addEngineSizeToQuery(queryParams, engineSize);
        if (shortenedModel) {
            return this.doRequest("/vehicle-doors-annual?".concat(queryParams, "&vehicleShortenedModel=").concat(shortenedModel));
        }
        else {
            return this.doRequest("/vehicle-doors?".concat(queryParams));
        }
    };
    FalconConvenienceApiServiceImpl.prototype.getVehicleStyles = function (manufacturer, manufactureYear, transmission, fuelType, engineSize, doors) {
        var queryParams = "vehicleManufacturer=".concat(manufacturer, "&manufactureYear=").concat(manufactureYear, "&transmission=").concat(transmission, "&fuelCode=").concat(fuelType, "&doors=").concat(doors);
        queryParams = this.addEngineSizeToQuery(queryParams, engineSize);
        return this.doRequest("/vehicle-styles?".concat(queryParams));
    };
    FalconConvenienceApiServiceImpl.prototype.getVehicleModelDetails = function (vehicleManufacturer, manufactureYear, transmission, fuelCode, partialVehicleModel) {
        return this.doRequest("/vehicle-model-lookup?vehicleManufacturer=".concat(vehicleManufacturer, "&manufactureYear=").concat(manufactureYear, "&transmission=").concat(transmission, "&fuelCode=").concat(fuelCode, "&partialVehicleModel=").concat(partialVehicleModel));
    };
    FalconConvenienceApiServiceImpl.prototype.getAnnualVehicleShortenedModelDetails = function (manufacturer, shortenedModel) {
        var queryParams = "vehicleManufacturer=".concat(manufacturer, "&vehicleShortenedModel=").concat(shortenedModel);
        return this.doRequest("/vehicle-shortened-model-lookup-annual?".concat(queryParams));
    };
    FalconConvenienceApiServiceImpl.prototype.getAnnualVehicleModelDetails = function (manufacturer, manufactureYear, transmission, fuelType, engineSize, doors, style, shortenedModel, model) {
        var queryParams = "vehicleManufacturer=".concat(manufacturer, "&manufactureYear=").concat(manufactureYear) +
            "&transmission=".concat(transmission, "&fuelCode=").concat(fuelType, "&doors=").concat(doors, "&bodyStyle=").concat(style, "&vehicleShortenedModel=").concat(shortenedModel, "&partialVehicleModel=").concat(model);
        queryParams = this.addEngineSizeToQuery(queryParams, engineSize);
        return this.doRequest("/vehicle-model-lookup-annual?".concat(queryParams));
    };
    FalconConvenienceApiServiceImpl.prototype.postcodeExists = function (postcode) {
        return this.doRequest("/postcode-lookup?postcode=".concat(postcode));
    };
    FalconConvenienceApiServiceImpl.prototype.getFurnishingTypeParams = function () {
        return this.doRequest("/furnishing-types");
    };
    FalconConvenienceApiServiceImpl.prototype.getRealEstateTypeSubtypeParams = function (product) {
        return this.doRequest("/real-estate-type-subtypes?product=".concat(product));
    };
    FalconConvenienceApiServiceImpl.prototype.getCustomerCancellationReasons = function (product) {
        return this.doRequest("/customer-cancellation-reasons?product=".concat(product));
    };
    FalconConvenienceApiServiceImpl.prototype.getImages = function (reference) {
        return this.doRequest("/images?reference=".concat(reference));
    };
    FalconConvenienceApiServiceImpl.prototype.deleteImage = function (reference, imageId) {
        return this.doRequest("/images/".concat(imageId, "?reference=").concat(reference), "DELETE");
    };
    FalconConvenienceApiServiceImpl.prototype.deleteByReference = function (reference) {
        return this.doRequest("/images?reference=".concat(reference), "DELETE");
    };
    FalconConvenienceApiServiceImpl.prototype.postImage = function (reference, base64, filename) {
        var body = {
            image: base64,
            filename: filename
        };
        return this.doRequest("/images?reference=".concat(reference), "POST", body);
    };
    FalconConvenienceApiServiceImpl.prototype.getSettings = function () {
        return this.doRequest("/settings");
    };
    FalconConvenienceApiServiceImpl.prototype.getAllProductClassifiers = function (product) {
        return this.doRequest("/classifier/".concat(product, "/all"));
    };
    FalconConvenienceApiServiceImpl.prototype.getClassifiers = function (classifierName, fieldValue) {
        var requestUrl = "/classifier/".concat(classifierName);
        if (fieldValue !== undefined) {
            requestUrl = requestUrl.concat("?fieldValue=".concat(fieldValue));
        }
        return this.doRequest(requestUrl);
    };
    FalconConvenienceApiServiceImpl.prototype.doRequest = function (urlAppend, method, body, onErrorReturn) {
        var _this = this;
        return _super.prototype.getProtectedResource.call(this, {
            body: body,
            method: method || "GET",
            headers: this.configuration.customHeaders,
            url: "".concat(this.configuration.serviceBaseUrl).concat(urlAppend),
        }, this.configuration.customQueryStringParameters, false).pipe((0, operators_1.map)(function (response) {
            return response.response;
        }), (0, operators_1.catchError)(function (err) {
            _this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.of)(onErrorReturn || {});
        }));
    };
    FalconConvenienceApiServiceImpl.prototype.addEngineSizeToQuery = function (queryParams, engineSize) {
        if (engineSize) {
            queryParams = queryParams + "&engineSize=".concat(engineSize);
        }
        return queryParams;
    };
    __decorate([
        (0, Cache_1.CacheObservable)(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", rxjs_1.Observable)
    ], FalconConvenienceApiServiceImpl.prototype, "getSettings", null);
    __decorate([
        (0, Cache_1.CacheObservable)(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], FalconConvenienceApiServiceImpl.prototype, "getAllProductClassifiers", null);
    __decorate([
        (0, Cache_1.CacheObservable)(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", rxjs_1.Observable)
    ], FalconConvenienceApiServiceImpl.prototype, "getClassifiers", null);
    FalconConvenienceApiServiceImpl = __decorate([
        (0, core_1.injectable)(),
        __param(0, (0, core_1.inject)(Types_1.Types.FalconConvenienceApiServiceConfig)),
        __param(1, (0, core_1.inject)(Types_1.Types.NotificationService)),
        __metadata("design:paramtypes", [Object, Object])
    ], FalconConvenienceApiServiceImpl);
    return FalconConvenienceApiServiceImpl;
}(core_1.RestService));
//# sourceMappingURL=FalconConvenienceApiServiceImpl.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/services/impl/FalconConvenienceApiServiceImpl.js
// module id = 2483
// module chunks = 0